import styled, { css } from 'styled-components';

import colors from '@utils/colors';
import { mq } from '@utils/responsive';
import { CONTENT_MAX_WIDTH, H_PADDING_MOBILE } from '@utils/space';
import { fontStyles, Heading as UnstyledHeading } from '@components/type';

export const Em = styled.span`
  font-style: italic;
`;

export const Hash = styled.a`
  color: ${colors.P200};
  margin-left: -36px;
  margin-right: 12px;
  font-weight: 300;
  opacity: 0;
`;

export const Heading = styled(UnstyledHeading)`
  padding-top: 96px;
  margin-top: -96px;

  &:hover ${Hash} {
    opacity: 1;
  }
`;

export const SidebarWrapper = styled.div`
  padding-bottom: 16px;

  ${mq.gtmd`
    width: ${(4 / 12) * 100}%;
    min-width: 300px;
    padding-bottom: 32px;

    ${(props) =>
      props.align === 'right'
        ? css`
            float: right;
            margin-left: 32px;
          `
        : css`
            float: left;
            margin-right: 32px;
          `}
  `}
`;

export const textBoxHeadings = css`
  & h1 {
    ${fontStyles.h1};
  }

  & h2 {
    ${fontStyles.h2};
    padding-top: 24px;
    font-size: 40px;
    line-height: 95%;
    color: ${colors.B500};
    text-transform: uppercase;

    ${mq.gtmd`
      font-size: 56px;
    `}

    ${mq.gtlg`
      font-size: 64px;
    `}
  }

  & h3 {
    ${fontStyles.h3};
  }

  & h4 {
    ${fontStyles.h4};
  }

  & h1,
  & h2,
  & h3 {
    text-transform: uppercase;
  }
`;

export const TextWrapper = styled.div`
  margin-bottom: ${(props) => (props.type === 'normal' ? '24px' : '32px')};

  &:has(ul), &:has(ol) {
    margin-bottom: 0;
  }

  & p {
    ${fontStyles.normal};
  }

  ${textBoxHeadings};

  & blockquote {
    ${fontStyles.blockquote};
  }

  & em {
    ${fontStyles.em};
  }

  & strong {
    ${fontStyles.strong};
  }

  & ul {
    ${fontStyles.normal};
    padding-left: 40px;
    list-style-type: disc;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  z-index: 1;
  transform: translate(0, 0);

  ${(props) =>
    !props.noPadding &&
    css`
      max-width: ${CONTENT_MAX_WIDTH}px;
      margin: 0 auto;
      padding: 0 ${H_PADDING_MOBILE};

      ${mq.gtml`
      padding: 0;
      `}

      &:not(:last-child) {
        margin-bottom: 24px;
      }

      & > ${TextWrapper}:last-child {
        margin-bottom: 0;
      }

      & > ${TextWrapper}:first-child h2,
      & > ${SidebarWrapper} + ${TextWrapper} h2 {
        padding-top: 0;
      }
    `}

  ${(props) => props.noPadding && css`
    ${TextWrapper}:last-child {
      margin-bottom: 0;
    }
  `}
  ${(props) => props.$columns === 2 && css`
    ${mq.gtmd`
      column-count: 2;
      column-gap: 48px;

      & li {
        break-inside: avoid;
      }

      & h1,
      & h2,
      & h3,
      & h4,
      & h5,
      & h6 {
        break-after: avoid;
      }
    `}
  `}
`;
